<ng-container *ngIf="!!revision && !!thumbnailUrl; else loadingTemplate">
  <ng-container *ngIf="!!revision.videoFile; else imageTemplate">
    <ng-container *ngIf="videoJsReady; else simpleLoadingTemplate">
      <ng-container *ngIf="!!revision.encodedVideoFile; else stillProcessingTemplate">
        <video
          #videoPlayerElement
          [attr.data-setup]="videoSetup"
          [attr.poster]="thumbnailUrl"
          [style.max-width.px]="optimalMaxWidth"
          class="video-js vjs-default-skin"
          controls
          preload="auto"
        >
          <source src="{{ revision.encodedVideoFile }}" type="video/mp4" />
        </video>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #imageTemplate>
  <img
    [alt]="image.title"
    [src]="thumbnailUrl"
    [style.max-width.px]="optimalMaxWidth"
    (intentionalClick)="onClick($event)"
    (load)="onLoad($event)"
    (mouseenter)="imageMouseEnter.emit($event)"
    (mouseleave)="imageMouseLeave.emit($event)"
    id="image-{{ id }}{{ image.hash ? '-' + image.hash : '' }}-{{ revisionLabel }}-{{ alias }}"
    class="astrobin-image"
    astrobinPreventScrollClick
  />
</ng-template>

<ng-template #loadingTemplate>
  <div [style.padding]="!!height ? 0 : '2rem'" class="loading-container">
    <astrobin-loading-indicator
      [message]="
        revision && revision.imageFile && revision.imageFile.toLowerCase().endsWith('.gif')
          ? ('Loading GIF animation...' | translate)
          : ''
      "
      [progress]="imageLoadingProgress"
    ></astrobin-loading-indicator>
  </div>
</ng-template>

<ng-template #simpleLoadingTemplate>
  <div [style.padding]="!!height ? 0 : '2rem'" class="loading-container">
    <astrobin-loading-indicator></astrobin-loading-indicator>
  </div>
</ng-template>

<ng-template #stillProcessingTemplate>
  <div class="loading-container">
    <astrobin-loading-indicator
      [message]="'This video is still processing, please return to this page later.' | translate"
      [progress]="videoEncodingProgress"
      class="video-still-processing py-5"
    ></astrobin-loading-indicator>
  </div>
</ng-template>
